import { useMemo } from 'react';
import { useRoutesContext } from '../index';

import { EMPTY_ARRAY } from 'shared/constants';

export const useActiveRouteStationRecommendationsCount = () => {
  const { activeRoute } = useRoutesContext();
  const { stationRecommendations } = activeRoute || {};
  const { perCountry = EMPTY_ARRAY } = stationRecommendations || {};

  return useMemo(() => perCountry.reduce((acc, { allStations }) => {
    acc += allStations.length;
    return acc;
  }, 0), [perCountry]);
};
